/* globals document */

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

const Modals = () => {
  const modal = useSelector((state) => state.modal);

  const { currentModal } = modal;

  if (!currentModal) {
    return null;
  }

  return ReactDOM.createPortal(currentModal, document.body);
};

export default Modals;
